function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m12 3c0.277 0 0.5 0.223 0.5 0.5v17c0 0.277-0.223 0.5-0.5 0.5s-0.5-0.223-0.5-0.5v-17c0-0.277 0.223-0.5 0.5-0.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m14.5 7c-0.277 0-0.5 0.223-0.5 0.5v10c0 0.277 0.223 0.5 0.5 0.5h6c0.277 0 0.5-0.223 0.5-0.5v-10c0-0.277-0.223-0.5-0.5-0.5zm0.5 1h5v9h-5z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m3.5 7c-0.277 0-0.5 0.223-0.5 0.5v10c0 0.277 0.223 0.5 0.5 0.5h6c0.277 0 0.5-0.223 0.5-0.5v-10c0-0.277-0.223-0.5-0.5-0.5zm0.5 1h5v9h-5z"
});

var SvgSplitter = function SvgSplitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSplitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/splitter.4f232e0b.svg";
export { ForwardRef as ReactComponent };